import { DataTable } from "../components/DataTable";
import { StatusPill } from "../components/StatusPill";
import { formatRelative } from "../lib/format";
import { fetchDashboardAudit } from "../lib/dashboard";
import { DashboardStateView, useDashboardQuery } from "../hooks/useDashboardQuery";

export function AuditTrailPage() {
  const state = useDashboardQuery(fetchDashboardAudit);

  return (
    <>
      <div className="page-header">
        <div>
          <h1>Audit trail</h1>
          <p>
            Allowlisted immutable audit events for this tenant (default 25, max 100). Metadata and
            secrets are never rendered.
          </p>
        </div>
        <StatusPill label="Read-only" tone="neutral" />
      </div>
      <DashboardStateView
        state={state}
        emptyTitle="No audit entries"
        emptyDetail="No immutable audit events are recorded for this tenant yet."
      >
        {(data) => (
          <div className="panel">
            <div className="panel-body" style={{ paddingTop: 0 }}>
              <DataTable
                rows={data.entries}
                rowKey={(r) => `${r.at}-${r.action}-${r.entityId ?? ""}`}
                columns={[
                  { key: "when", header: "When", render: (r) => formatRelative(r.at) },
                  { key: "action", header: "Action", render: (r) => r.action },
                  {
                    key: "entity",
                    header: "Entity",
                    render: (r) =>
                      r.entityType ? (
                        <span className="mono">
                          {r.entityType}
                          {r.entityId ? `:${r.entityId}` : ""}
                        </span>
                      ) : (
                        "—"
                      ),
                  },
                  {
                    key: "actor",
                    header: "Actor",
                    render: (r) => (
                      <span className="mono">
                        {r.actorType ?? "—"}
                        {r.actorId ? `/${r.actorId}` : ""}
                      </span>
                    ),
                  },
                  { key: "reason", header: "Reason", render: (r) => r.reason ?? "—" },
                ]}
              />
            </div>
          </div>
        )}
      </DashboardStateView>
    </>
  );
}
